<template>
  <div class="form-container" style="position: relative;">
    <el-form ref="form" label-position="top" :rules="rules" :model="formLabelAlign" class="product-form" label-width="100px;">
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="firstName">
          <label slot="label">{{ $t('first_name') }}</label>
            <el-input maxlength="100" class="gray-theme" v-model="formLabelAlign.firstName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="lastName">
          <label slot="label">{{ $t('last_name') }}</label>
            <el-input maxlength="100" class="gray-theme" v-model="formLabelAlign.lastName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="type">
            <label slot="label">{{ $t('role') }}</label>
            <el-select v-model="formLabelAlign.type" disabled class="gray-theme">
              <el-option
                v-for="item in typeOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="8">
          <el-form-item prop="cellphone">
            <label slot="label">{{ $t('cellphone') }}</label>
            <el-input maxlength="20" class="gray-theme" v-model="formLabelAlign.cellphone" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="email">
            <label slot="label">{{ $t('email') }}</label>
            <el-input class="gray-theme" v-model="formLabelAlign.email" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="16">
          <el-form-item prop="company" style="width: 100%">
            <label slot="label">{{ $t('company') }}</label>
            <el-input maxlength="200" class="gray-theme" v-model="formLabelAlign.company"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="address" style="width: 100%">
            <label slot="label">{{ $t('address') }}</label>
            <el-input maxlength="200" class="gray-theme" v-model="formLabelAlign.address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-form-item style="width: 100%">
            <label slot="label">{{ $t('address2') }}</label>
            <el-input maxlength="200" class="gray-theme" v-model="formLabelAlign.address2"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="30">
        <el-col :span="6">
          <el-form-item prop="city" style="width: 100%">
            <label slot="label">{{ $t('city') }}</label>
            <el-input maxlength="100" class="gray-theme" v-model="formLabelAlign.city"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="zip" style="width: 100%">
            <label slot="label">{{ $t('zip') }}</label>
            <el-input maxlength="100" class="gray-theme" v-model="formLabelAlign.zip"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="state" style="width: 100%">
            <label slot="label">{{ $t('state') }}</label>
            <el-input maxlength="100" class="gray-theme" v-model="formLabelAlign.state"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="country" style="width: 100%">
            <label slot="label">{{ $t('country') }}</label>
            <el-select v-model="formLabelAlign.country" class="gray-theme" filterable style="width: 100%">
              <el-option
                v-for="item in countryOptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="4">
          <el-form-item prop="sex" style="width: 100%">
            <template>
              <label slot="label">{{ $t('sex') }}</label>
              <el-select v-model="formLabelAlign.sex" class="gray-theme">
                <el-option
                  v-for="item in sexOptions"
                  :key="item.code"
                  :label="item.name"
                  :value="item.code"
                />
              </el-select>
            </template>
          </el-form-item>
        </el-col> -->
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-divider></el-divider>
        </el-col>
        <el-col :span="24">
          <el-form-item style="width: 30%">
            <label slot="label">{{ $t('old_password') }}</label>
            <el-input maxlength="100" class="gray-theme" show-password :placeholder="$t('enter_old_password')" v-model="formLabelAlign.password"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item style="width: 60%;margin-bottom: 0" prop="newPassword">
            <label slot="label">{{ $t('new_password') }}</label>
            <el-input maxlength="100" class="gray-theme" show-password :placeholder="$t('enter_new_password')" v-model="formLabelAlign.newPassword"></el-input>
          </el-form-item>
          <div class="password-info" style="width: 58%">{{ $t('password_least') }}</div>
        </el-col>
        <el-col :span="12">
          <el-form-item style="width: 60%" prop="confirmPassword">
            <label slot="label">{{ $t('confirm_password') }}</label>
            <el-input maxlength="100" class="gray-theme" show-password :placeholder="$t('enter_confirm_password')" v-model="formLabelAlign.confirmPassword"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import userApi from '@/apis/user';

export default {
  data() {
    // var validatePass = (rule, value, callback) => {
    //   if (value === '') {
    //     callback(new Error(this.$t('input_password')));
    //   } else {
    //     if (!this.$formLabelAlign.newPassword.test(value)) {
    //       callback(
    //         new Error(
    //           this.$t('password_error')
    //         )
    //       );
    //     }
    //     callback();
    //   }
    // };
    var checkPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('input_password_again')));
      } else if (value !== this.formLabelAlign.newPassword) {
        callback(new Error(this.$t('password_error_two')));
      } else {
        callback();
      }
    };
    return {
      sexOptions: [
        {
          name: this.$t('male'),
          code: 10
        },
        {
          name: this.$t('female'),
          code: 20
        },
        {
          name: this.$t('other'),
          code: 30
        }
      ],
      countryOptions: [],
      typeOptions: [
        {
          name: this.$t('user'),
          code: 10
        },
        {
          name: this.$t('dealer'),
          code: 20
        }
      ],
      formLabelAlign: {
        firstName: '',
        lastName: '',
        type: '',
        company: '',
        country: '',
        sex: '',
        zip: '',
        email: '',
        address: ''
      },
      formPassWord: {
        password: '',
        newPassword: '',
        confirmPassword: ''
      },
      dialogVisible: false,
      Product: '',
      moduleListData: [],
      rules: {
        firstName: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        lastName: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        sex: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        zip: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        country: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        company: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        address: [
          {
            required: true,
            message: this.$t('required'),
            trigger: 'blur'
          }
        ],

        confirmPassword: [{ validator: checkPass, trigger: 'blur' }]
      }
    };
  },

  model: {
    prop: 'modelData',
    event: 'change'
  },

  props: {
    modelData: {
      type: Object,
      default: () => {}
    },
    rowVal: {
      type: Object,
      default: () => {}
    }
  },

  components: {},

  computed: {},

  mounted() {
    this.init();
    userApi.getCountry().then(response => {
      this.countryOptions = response.list;
    });
  },

  beforeDestroy() {},

  watch: {},

  methods: {
    init() {
      this.formLabelAlign = this.rowVal;
    },

    Submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.modifyUserInfo();
        } else {
          return false;
        }
      });
    },

    async modifyUserInfo() {
      const req = {
        ...this.formLabelAlign
      };
      const res = await userApi.UserInfoChange(req);
      if (Object.prototype.hasOwnProperty.call(req, 'password')) {
        return this.modifyPassword();
      }
      if (res.reason) {
        this.$message({
          message: this.$t('email_used'),
          type: 'error',
          center: true,
          duration: 5000
        });
      } else {
        this.$message({
          message: this.$t('information_success'),
          type: 'success',
          center: true,
          duration: 5000
        });
        this.$emit('closeAction', false);
      }
    },

    async modifyPassword() {
      // debugger;
      const reqPassword = {
        ...this.formLabelAlign
      };
      const resPassword = await userApi.UserPasswordChange(reqPassword);
      if (resPassword.reason) {
        this.$message({
          message: this.$t('old_password_error'),
          type: 'error',
          center: true,
          duration: 5000
        });
      } else {
        this.$message({
          message: this.$t('update_password_success'),
          type: 'success',
          center: true,
          duration: 5000
        });
        this.$emit('closeAction', false);
      }
    }
  }
};
</script>

<style lang="scss">
.product-form {
  .el-form-item__label {
    float: left !important;
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #292929;
    padding: 0 !important;
  }
  .el-form-item__content {
    text-align: left;
    .el-textarea__inner {
      height: 80px;
    }
  }
}

.el-divider {
  background: #c7c8c9;
}

.price-suffix {
  .el-input__inner {
    padding-right: 90px;
  }
}

.suffix-title {
  font-size: 16px;
  color: #292929;
}

.password-info {
  width: 300px;
  font-size: 12px;
  text-align: left;
  color: #292929;
  line-height: 12px;
  word-break: break-word;
}
</style>
